.logo {
  display: flex;

  > * {
    max-width: 100%;
    height: 1em;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0.5em;
    border-radius: 0.33em;
  }
}
